import { onAccountError, post, type SERVICE_CONFIG } from '../utils/FetchV2.util';

export interface DownloadLink {
  path: string;
  expires_at: string;
}

type ErrorWithStatus = { response?: { status?: number } };

/**
 * Asks a backend for a short-lived (5 minutes) signed link to a file it builds or
 * reads on demand. The link needs no session: the system browser opens it from the
 * native app. `skipAccountError` makes every failure throw, so the caller sees the
 * 409 and 404 the endpoints answer with; a 401 still ends the session as everywhere.
 */
export const requestDownloadLink = async (
  service: keyof typeof SERVICE_CONFIG,
  endpoint: string,
  body: object,
): Promise<DownloadLink> => {
  try {
    const link = await post<DownloadLink | undefined>({ service, endpoint, body, skipAccountError: true });
    if (!link?.path) throw new Error('download_link_path_missing');
    return link;
  } catch (error) {
    if ((error as ErrorWithStatus)?.response?.status === 401) onAccountError(error);
    throw error;
  }
};
